import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "fdca3cc0-b80d-481a-979b-bd5ac44ca9dd",
    authority:
      process.env.REACT_APP_AZURE_AUTHORITY ||
      "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}/dashboard`,
  },
  cache: {
     cacheLocation: "localStorage",
    //cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "User.Read",
    "api://526a3a0e-b29a-4891-a80e-ed3f575b8f3d/access_as_user",
  ],
  prompt: "select_account",
  // prompt: "login",

  redirectUri: `${window.location.origin}/dashboard`,
};

export const logoutRequest = {
  postLogoutRedirectUri: window.location.origin,
};

export const apiScopes = {
  scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID}/access_as_user`],
};

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance
let msalInitialized = false;

export const initializeMsal = async () => {
  if (!msalInitialized) {
    await msalInstance.initialize();
    msalInitialized = true;
  }
  return msalInstance;
};
